/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Upload_Mobi_EpubInputs */

const en_homepage_features_upload_mobi_epub = /** @type {(inputs: Homepage_Features_Upload_Mobi_EpubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MOBI & EPUB`)
};

const es_homepage_features_upload_mobi_epub = /** @type {(inputs: Homepage_Features_Upload_Mobi_EpubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MOBI y EPUB`)
};

/**
* | output |
* | --- |
* | "MOBI & EPUB" |
*
* @param {Homepage_Features_Upload_Mobi_EpubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_upload_mobi_epub = /** @type {((inputs?: Homepage_Features_Upload_Mobi_EpubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Upload_Mobi_EpubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_upload_mobi_epub(inputs)
	return en_homepage_features_upload_mobi_epub(inputs)
});